import { configureStore } from '@reduxjs/toolkit';
import claimReducer from './slices/claimSlice';
import policyReducer from './slices/policySlice';
import layoutSettingReducer from './slices/layoutSlice';

export const store = configureStore({
  reducer: {
    claim: claimReducer,
    policy: policyReducer,
    layoutSetting: layoutSettingReducer,
  },
});

export * from './slices';
